import React, { useEffect, useLayoutEffect, useRef } from 'react';

import styles from './welcome-container.module.scss';
import { MAX_FONT_SIZE } from '../../../utils/constants';

interface WelcomeContainerProps {
  children: React.ReactNode;
  className?: string;
  classList?: { [key: string]: boolean };
  style?: React.CSSProperties;
}

const MIN_FONT_SIZE = 10;

export const WelcomeContainer: React.FC<WelcomeContainerProps> = ({ children, className, style }) => {
  const ref = useRef(null);
  
  const fit = () => {
    const el = ref.current;
    
    if (!el) {
      return;
    }
    
    let size = MAX_FONT_SIZE;
    el.style.fontSize = size + 'px';
    
    while ((el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight) && size > MIN_FONT_SIZE) {
      size -= 1;
      el.style.fontSize = size + 'px';
    }
  };
  
  useLayoutEffect(() => {
    requestAnimationFrame(fit);
  }, [ children ]);
  
  useEffect(() => {
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, []);
  
  
  return (
    <div
      ref={ref}
      className={`${styles['welcome-container']} ${className || ''}`}
      style={style}
    >
      {children}
    </div>
  );
}